import { Link } from "react-router-dom";
import { Github, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer style={{ borderTop: "1px solid var(--stone)", background: "var(--cream)", padding: "48px 0 32px" }}>
      <div className="container">
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: 32,
          marginBottom: 40
        }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
              <div style={{
                width: 28, height: 28, borderRadius: 8,
                background: "var(--accent)", color: "white",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 12
              }}>TG</div>
              <span style={{ fontFamily: "var(--font-display)", fontWeight: 600, fontSize: 16 }}>TokenGuard</span>
            </div>
            <p style={{ fontSize: 13.5, color: "var(--slate)", lineHeight: 1.6, maxWidth: 260 }}>
              Monitor, alert, and control your LLM token usage across every provider.
            </p>
          </div>

          <div>
            <h4 style={{ fontSize: 13, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: 14, color: "var(--charcoal)" }}>Product</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <Link to="/download" style={{ fontSize: 14, color: "var(--slate)" }}>Download</Link>
              <Link to="/" style={{ fontSize: 14, color: "var(--slate)" }}>Features</Link>
              <a href="#pricing" style={{ fontSize: 14, color: "var(--slate)" }}>Pricing</a>
            </div>
          </div>

          <div>
            <h4 style={{ fontSize: 13, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: 14, color: "var(--charcoal)" }}>Company</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <Link to="/contact" style={{ fontSize: 14, color: "var(--slate)" }}>Contact</Link>
              <Link to="/privacy" style={{ fontSize: 14, color: "var(--slate)" }}>Privacy</Link>
              <Link to="/terms" style={{ fontSize: 14, color: "var(--slate)" }}>Terms</Link>
            </div>
          </div>

          <div>
            <h4 style={{ fontSize: 13, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: 14, color: "var(--charcoal)" }}>Connect</h4>
            <div style={{ display: "flex", gap: 14 }}>
              <a href="https://github.com/mytokenguard" target="_blank" rel="noreferrer" style={{ color: "var(--slate)" }}>
                <Github size={20} />
              </a>
              <a href="https://twitter.com/mytokenguard" target="_blank" rel="noreferrer" style={{ color: "var(--slate)" }}>
                <Twitter size={20} />
              </a>
            </div>
          </div>
        </div>

        <div style={{ borderTop: "1px solid var(--stone)", paddingTop: 20, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
          <p style={{ fontSize: 12.5, color: "var(--muted-slate)" }}>
            &copy; {new Date().getFullYear()} TokenGuard. All rights reserved.
          </p>
          <p style={{ fontSize: 12.5, color: "var(--muted-slate)" }}>
            Built with care for the LLM era.
          </p>
        </div>
      </div>
    </footer>
  );
}
